import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ClientForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      await api.post("/portal/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  if (sent) return (
    <AuthShell title="Check your inbox" subtitle="If an account exists for that email, a password reset link is on its way.">
      <Link to="/client/login" className="text-sm text-[#D4AF37] hover:underline">Back to sign in</Link>
    </AuthShell>
  );

  return (
    <AuthShell title="Reset your password" subtitle="Enter your email and we'll send you a reset link.">
      <form onSubmit={submit} className="space-y-4" data-testid="client-forgot-form">
        <div><Label className="text-[#D4D4D8] mb-1.5 block">Email</Label>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="client-forgot-email" placeholder="you@company.com" className="bg-[#121214] border-white/10 text-white h-11" /></div>
        {error && <p className="text-sm text-red-400">{error}</p>}
        <Button type="submit" disabled={loading} data-testid="client-forgot-submit"
          className="w-full fv-gold-gradient text-[#0A0A0B] font-semibold h-11 rounded-lg hover:opacity-90">
          {loading ? "Sending…" : "Send reset link"}</Button>
      </form>
      <Link to="/client/login" className="block text-center text-sm text-[#A1A1AA] mt-6 hover:text-white">Back to sign in</Link>
    </AuthShell>
  );
}
